import { useQuery } from '@tanstack/react-query'
import { fileHistoryRes } from '@/types/question.type'
import { axiosInstance } from '@/lib/axios'

export const getFileHistory = async (moduleId: string) => {
  return axiosInstance.get<fileHistoryRes>(`/question/file/${moduleId}`)
}

export const useGetFileHistory = (moduleid: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ['file_history', moduleid],
    queryFn: () => getFileHistory(moduleid),
    enabled: !!moduleid,
  })

  return {
    files: data?.data,
    isLoadingFiles: isLoading,
  }
}
